<template>
  <component
    :is="resourceCollection()"
    :mode="mode"
    :name="name"
    :options="legacyOptions()"
    :pagination="pagination ?? config.pagination"
    :resource="models"
    :meta="models.meta"
    @detach="(detached) => $emit('detach', detached)"
    @updatePicked="updatePicked"
    @trigger:refresh="(data, page) => $emit('trigger:refresh', data, page)"
    @update:data="(data) => $emit('update:data', data)"
    @update:relation="(data) => $emit('update:relation', data)"
  ></component>
</template>

<script>
import ColumnHeader from '@kanrisha/components/Collection/List/ColumnHeader';
import Pagination from '@kanrisha/components/Pagination';
import PresentationField from '@kanrisha/components/Presentation/PresentationField';
import { Link, usePage } from '@inertiajs/vue3';
import ResourceAction from '@kanrisha/components/Links/ResourceAction';
// import useCustomComponent from "@kanrisha/composables/useCustomComponent";
import useResource from '@kanrisha/composables/useResource';
import { defineAsyncComponent, ref } from 'vue';

export default {
  components: {
    ColumnHeader,
    Link,
    Pagination,
    PresentationField,
    ResourceAction,
  },
  props: {
    collectionType: { type: String, default: null }, // => config?
    models: { type: Object, default: () => {} },
    mode: { type: String, default: 'component' }, // => config? deprecated?
    name: { type: String, default: 'default' },
    options: { type: Object, default: () => {} },
    titleAttribute: { type: String, default: null }, // deprecated => options
    targetAttribute: { type: String, default: null }, // deprecated => options
    imageAttribute: { type: String, default: null }, // deprecated => options
    pagination: { type: Boolean, default: () => true }, // => config? (showPagination)
  },
  emits: ['addToast', 'updatePicked', 'update:data', 'update:relation', 'trigger:refresh', 'detach'],
  setup(props, { emit }) {
    const localType = ref(props.collectionType[0].toUpperCase() + props.collectionType.slice(1));
    const { adjustments, config, meta, resourceType } = useResource(props, props.models);

    // const { customComponent } = useCustomComponent();

    const resourceCollection = () => {
      let type = props.collectionType
        ? props.collectionType[0].toUpperCase() + props.collectionType.slice(1)
        : props.config.component.type;
      // if (type !== 'List' && type !== 'Carousel') {
      //   return null;
      // }

      try {
        let aspect = usePage().props.admin_request ? 'admin' : usePage().props.aspect;
        require(`@/aspects/${aspect}/components/Collection/Resource${type}.vue`);

        return defineAsyncComponent(() => import(`@/aspects/${aspect}/components/Collection/Resource${type}.vue`));
      } catch (e) {
        try {
          let structure = usePage().props.structure;
          require(`@/structures/${structure}/components/Collection/Resource${type}.vue`);

          return defineAsyncComponent(() => import(`@/structures/${structure}/components/Collection/Resource${type}.vue`));
        } catch (e) {
          //
        }
      }
      return defineAsyncComponent(() => import(`./Collection/Resource${type}.vue`));
    };

    const legacyOptions = () => {
      let options = props.options ?? {};
      if (props.titleAttribute) options.titleAttribute = props.titleAttribute;
      if (props.targetAttribute) options.targetAttribute = props.targetAttribute;
      if (props.imageAttribute) options.imageAttribute = props.imageAttribute;

      // todo: keep these but make them configurable in schema
      options.title_key = 'name';
      options.sub_title_key = null;

      return options;
    };

    const updatePicked = (data) => {
      emit('updatePicked', data);
    };

    return {
      // customComponent,
      adjustments,
      config,
      legacyOptions,
      localType,
      meta,
      resourceCollection,
      resourceType,
      updatePicked,
    };
  },
};
</script>
